import { Stack } from '@mui/material';

import { TREATMENT_SERVICE_ROWS } from '../constants';
import TreatmentServiceRow from './TreatmentServiceRow';

import type { TreatmentServicesListProps } from './types';

export default function TreatmentServicesList({
  formik,
  disabled,
  readOnly,
  saveField,
}: TreatmentServicesListProps) {
  return (
    <Stack>
      {TREATMENT_SERVICE_ROWS.map((row, index) => (
        <TreatmentServiceRow
          key={row.hoursName}
          disabled={disabled}
          formik={formik}
          index={index}
          readOnly={readOnly}
          row={row}
          saveField={saveField}
        />
      ))}
    </Stack>
  );
}
